export const personalInfo = {
  name: "Shoaib Mansuri",
  title: "Software Engineer",
  tagline: "4+ years building high-performance application at enterprise scale",
  email: "shoaibmansuri235@gmail.com",
  phone: "8003740674",
  location: "Hyderabad, Telangana",
  github: "https://github.com/Shoaib20-1998",
  linkedin: "https://www.linkedin.com/in/shoaib-mansuri-7753b2218/",
  resumePath: "/Shoaib-Mansuri-Resume.pdf?v=2",
  profileImage: "/images/mypic.png"
};
